import React, {useRef, useState} from 'react';
import {RefreshControl, ScrollView, StyleSheet} from 'react-native';
import {observer} from 'mobx-react';

import PromotionTile from '../../components/articleTile/PromotionTile';
import LoadingImg from '../../components/LoadingImg';
import ScrollToTopButton from '../../components/ScrollToTopButton';
import ContentView from '../../components/ui-controls/layout/ContentView';
import WebFooter from '../../components/WebFooter';
import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AirtablePromotionItem} from '../../models/airtable';
import {useStores} from '../../stores/use-stores';

type PromotionsListScreenBaseProps = {
  promotions: AirtablePromotionItem[];
  testID?: string;
};
const PromotionsListScreenBase = observer(
  ({
    promotions,
    testID = 'promotions-list-screen-base',
  }: PromotionsListScreenBaseProps) => {
    const {promotionsStore: activationsStore, shopSelectionStore} = useStores();
    const {isWebDesktopScreen} = useWebScreenDimensions();

    // Scroll button stuff
    const [showScrollButton, setShowScrollButton] = useState(false);
    const listRef = useRef();
    const refresh = () => {
      const {selectedStore} = shopSelectionStore;
      const storeNumber = selectedStore?.store_number;
      const storeState =
        selectedStore?.address?.administrative_area?.toUpperCase();
      activationsStore.getPromotions(storeNumber, storeState);
    };

    return (
      <ContentView testID={testID}>
        {!!shopSelectionStore.storeLoading && <LoadingImg />}
        {!shopSelectionStore.storeLoading && (
          <>
            <ScrollView
              refreshControl={
                <RefreshControl refreshing={false} onRefresh={refresh} />
              }
              showsVerticalScrollIndicator={isWebDesktopScreen}
              showsHorizontalScrollIndicator={isWebDesktopScreen}
              contentContainerStyle={styles.main}
              // Handle scroll to top button
              onScrollBeginDrag={() => setShowScrollButton(true)}
              onMomentumScrollBegin={() => setShowScrollButton(true)}
              onMomentumScrollEnd={() => setShowScrollButton(false)}
              onScrollEndDrag={() => setShowScrollButton(false)}
              ref={listRef}>
              {promotions.map(promotion => (
                <PromotionTile promotion={promotion} key={promotion.id} />
              )) || null}
              {/* TODO: The WebFooter should be in a global/common place */}
              {!!isWebDesktopScreen && <WebFooter />}
            </ScrollView>
            <ScrollToTopButton
              open={showScrollButton}
              callback={() =>
                listRef.current.scrollTo({x: 0, y: 0, animated: true})
              }
            />
          </>
        )}
      </ContentView>
    );
  },
);

export default PromotionsListScreenBase;

const styles = StyleSheet.create({
  main: {
    backgroundColor: 'white',
    overflow: 'visible',
  },
});
